import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
	changeResultsTotal,
	receiveResult,
	receiveResultFailed,
	requestResult,
} from "./actions";
import useSearchState from "./useSearchState";
import { requestSearch } from "./api";
import { clearSearchParams, updateSearchParams } from "./utils";

export default function useRequestSearch(
	namespace,
	serverSidePaging,
	showResultsOnInitialPageLoad,
) {
	const dispatch = useDispatch();
	const {
		params,
		paramsExist,
		resultsPage,
		resultsPerPage,
		resultsSortColumn,
		resultsSortDirection,
	} = useSearchState();

	useEffect(() => {
		if (!showResultsOnInitialPageLoad && !paramsExist) {
			clearSearchParams(params);
			return;
		}

		updateSearchParams(params);
		requestSearchResult();

		const data = {
			...params,
			...{
				page: resultsPage - 1,
				page_size: resultsPerPage,
				sort: resultsSortColumn,
				ascending: resultsSortDirection === "asc",
			},
		};

		requestSearch(
			data,
			namespace,
			(result) => {
				if (serverSidePaging) {
					dispatch(receiveResult(result.items));
					dispatch(changeResultsTotal(result.paging.results));
				} else {
					dispatch(receiveResult(result));
				}
			},
			(error) => {
				dispatch(receiveResultFailed(error));
			},
		);
	}, [
		params,
		paramsExist,
		resultsPage,
		resultsPerPage,
		resultsSortColumn,
		resultsSortDirection,
	]);

	const requestSearchResult = () => {
		dispatch(requestResult());
	};
}
